import { render, staticRenderFns } from "./game-price.vue?vue&type=template&id=15d1ddaf&scoped=true"
import script from "./game-price.vue?vue&type=script&lang=js"
export * from "./game-price.vue?vue&type=script&lang=js"
import style0 from "./game-price.vue?vue&type=style&index=0&id=15d1ddaf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d1ddaf",
  null
  
)

export default component.exports